jQuery(document).ready(function ($){

  /* Event handlers for variant dropdowns */
  $(document).on('click','#quick-view .option-container.option-container-dropdown span:not(.option-value), #quick-view .option-container.option-container-mobile-dropdown span', function(){
    $(this).next('.option').slideToggle();
    $(this).toggleClass('open');
  });

  $(document).on('click','#quick-view .option-container .option.color .selection-container input', function(){
    $(this).closest('.option').slideToggle();
    $(this).closest('.option').prev().toggleClass('open');
  });

  $(document).on('click','#quick-view .option-container.option-container-dropdown label', function(){
    $(this).closest('.option').slideToggle();
    $(this).closest('.option').prev().toggleClass('open');
  });

  $(document).on("click", ".qv-add-button", function () {
    let product_handle = $("#quick-view").data('handle');
    let qty = $('.qv-quantity').val();
    let selectedOptions = '';
    let var_id = '';
    $('#quick-view input:radio:checked').each(function (i) {
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    $('#quick-view select').each(function (i) { 
      if (selectedOptions == '') {
        selectedOptions = $(this).val();
      } else {
        selectedOptions = selectedOptions + ' / ' + $(this).val();
      }
    });
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
      $(product.variants).each(function (i, v) {
        if (v.title == selectedOptions) {
          var_id = v.id;
        }
      });
    }).done(function() {
      processCart();
    });
    function processCart() {
      let freeGiftEligible = $("#qv-free-gift-eligible-product").val();
      var body;
      if (freeGiftEligible) {
        body = {
          quantity: qty,
          id: var_id,
          properties: {
            'free_gift_eligible': 'true'
          },
          sections: 'cart-icon-bubble,cart-drawer'
        };
      } else {
        body = {
          quantity: qty,
          id: var_id,
          sections: 'cart-icon-bubble,cart-drawer'
        };
      }
        jQuery.post('/cart/add.js', body,
        null,
        "json")
        .done(function (response) {
          window.postMessage({ type: 'quickview', action: "product_added" }, '*');
          $('.qv-add-to-cart-response')
            .addClass('success')
            .removeClass('error')
            .html('<span>' + $('.qv-product-title').text() + ' has been added to your <a href="/cart">CART</a>.');
          document.getElementById('cart-icon-bubble').innerHTML = response.sections['cart-icon-bubble'];
          document.getElementById('quick-view-atc').innerHTML = 'ADDED TO CART';
          
          
          $.fancybox.close();
          $(".header__icon--cart")[0].click();
          
        })
        .fail(function ($xhr) {
          var data = $xhr.responseJSON;
          $('.qv-add-to-cart-response')
            .addClass('error')
            .removeClass('success')
            .html('<span><b>ERROR: </b>' + data.description);
        }
    );  
  }
  });

  function quickView() {
    jQuery(document).on('click','.quick-view', function () {
      if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
      var product_handle = $(this).data('handle');
      var product_id = $(this).data('id');
      var dots = $(this).data('dots');
      var show_preorder = $(this).data('preorder');
      var slider_style = $(this).data('slider-style');
      var useDots = false;
      var product_external_link = $(this).data('external-link');
      if (dots == true && slider_style == 'default') {useDots = true;}
      window.postMessage({ type: 'quickview', action: "open", product: product_id }, '*')
      var sub_only = $(this).data('subscriber-only');
      $('#quick-view').addClass(product_handle);
      $('#quick-view').attr('data-handle', product_handle);
      $('#quick-view').data('handle', product_handle);

      jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
        var id = product.id;
        var title = product.title;
        var type = product.type;
        var price = 0;
        var original_price = 0;
        var desc = product.description;
        var images = product.images;
        var media = product.media;
        var variants = product.variants;
        var options = product.options;
        var sku = product.variants[0].sku;
        var store_url = "";
        var url = '/products/' + product_handle;
        $('.qv-product-title').text(title);
        $('.qv-product-type').text(type);
        $('.qv-product-sku').text("ITEM NO. " + sku);
        $('.qv-product-description').html(desc);
        $('.view-product').attr('href', url);
        if (variants[0].available == false) {
          $(".qv-add-button").prop("disabled", true);
          $('#quick-view-atc').text(window.variantStrings.soldOut);
        }

        //Subscription Product
        if (sub_only) {
          $(".subscriber-products-qv-container").removeClass("hidden");
          $(".qv-add-button, .qv-content .view-product").addClass("hidden");
        } else {
          $(".subscriber-products-qv-container").addClass("hidden");
          if (typeof(product_external_link) != 'undefined') {
            $(".qv-external-link").attr("href", product_external_link);
            $(".qv-external-link").removeClass("hidden");
            $(".qv-add-button").addClass("hidden");
          } else {
            $(".qv-external-link").addClass("hidden");
            $(".qv-add-button").removeClass("hidden");
          }
          $(".qv-content .view-product").removeClass("hidden");
        }

        //Preorder
        if (show_preorder == true) {
        $('#quick-view-atc').text(window.variantStrings.preOrder);
        var buttonLabel = show_preorder == true ? window.variantStrings.preOrder : window.variantStrings.addToCart;
        $('.qv-add-button').val(buttonLabel);
      }

        // Phone Cases
        for (var tag of product.tags) {
          if (tag.includes('Phone Cases')) {
            $('#quick-view .qv-content').addClass('phone-case'); 
          }
        }

        //Free Gift
        let freeGiftEligible = false;
        let freeGiftEligibleTag = "free-gift-eligible"
        for (var tag of product.tags) {
          if (tag === freeGiftEligibleTag) {
            freeGiftEligible = true;
          }
        }
        if (!freeGiftEligible) {
          $("#qv-free-gift-eligible-product").remove();
        }

        //Gallery
        var imageCount = $(media).length;
        $(media).each(function (i, media) {
          if (i == imageCount - 1) {
            var image_embed = '<div><img alt="'+ title + '" data-index="' + i + '" data-media-id="' + media.id + '" src="' + media.src + '"></div>';
            image_embed = image_embed.replaceAll('.jpg', '_800x.jpg').replaceAll('.png', '_800x.png');
            $('.qv-product-images, .qv-product-slider-nav').append(image_embed);
            /* Original 
            $('.qv-product-images').slick({
              dots: false,
              arrows: true,
              respondTo: 'min',
              useTransform: false
            }).css('opacity', '1');
            */
            $('.qv-product-images').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: true,
              fade: true,
              dots: useDots,
              variableWidth: false,
              infinite:true,
              asNavFor: '.qv-product-slider-nav',
              instructionsText: 'Changing this current slide of this carousel will change the current slide of the thumbnail carousel that follows.',
              regionLabel: 'main image carousel',
              prevArrow: '.qv-prev',
              nextArrow: '.qv-next'
            }).css('opacity', '1');
            $('.qv-product-slider-nav').slick({
              slidesToShow: Math.min(3, imageCount),
              slidesToScroll: 1,
              asNavFor: '.qv-product-images',
              arrows: true,
              dots: false,
              centerMode: true,
              instructionsText: 'Changing the current slide of this carousel will change the current slide of the preceding main image carousel.',
              regionLabel: 'thumbnail carousel',
              focusOnSelect: true,
              prevArrow: '.qv-subnav-prev',
              nextArrow: '.qv-subnav-next'
            }).css('opacity', '1');
            window.addEventListener('message', function(m) {
              if (!m.type == 'variant_changed') return false;
              if (!m.data.variant) return false;
              if (m.data.variant.available) {
                $('#quick-view-atc').text(window.variantStrings.addToCart);
              } else {
                $('#quick-view-atc').text(window.variantStrings.soldOut);
              }
              var vMediaId = m.data.variant.featured_media.id;
              var index = document.querySelector('img[data-media-id="' + vMediaId + '"]').dataset.index;
              $('.qv-product-images').slick('slickGoTo', index);
            });
          } else {
            var image_embed = '<div><img alt="'+ title + '" data-index="' + i + '" data-media-id="' + media.id + '" src="' + media.src + '"></div>';
            image_embed = image_embed.replaceAll('.jpg', '_800x.jpg').replaceAll('.png', '_800x.png');
            $('.qv-product-images, .qv-product-slider-nav').append(image_embed);
          }
        });

        $(options).each(function (i, option) {
          let optionStyle = "swatches";
          let optThreshold = "9";
          var opt = option.name;
          var optSeparator = "<div class='qv-separator'>:</div>";
          var optValue = option.values;
          var selectClass = '.option.' + opt.toLowerCase();
          var isSwatch = (opt == 'Color');
          var showLabel = true;
          var showFullSelection = false;
          //IF SHOW FULL SELECTION DECLARE THE NEW VARIABLE WITH REGEX TO REPLACE SHORT LABELS
          let fullLabel = optValue[0].replace(/^S$/g, "Small").replace(/^SM$/g, "Small").replace(/^M$/g, 'Medium').replace(/^XXXX/g, '4X-').replace(/^XXX/g, '3X-').replace(/^XX/g, '2X-').replace(/^X/g, 'X-').replace(/L$/g, 'Large');
          /* If variant style is set to dropdown except colors */
          if (optionStyle == 'dropdown_except_colors') {
            /* If variant style is set to dropdown except colors and option is a swatch */
            if (isSwatch) {
              if (showLabel) {
                if (showFullSelection) {
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container dropdown-except-color full"><span class="option-name">' + opt + optSeparator +' <span class="option-value full">' + fullLabel + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                } else {
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container dropdown-except-color"><span class="option-name">' + opt + optSeparator +' <span class="option-value">' + option.values[0] + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                }
              } else {
                $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container dropdown-except-color"><span class="option-name">' + opt + '<div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
              }
            /* If variant style is set to dropdown except colors and option is NOT swatch */
            } else {
              if (showLabel) {
                if (showFullSelection) {
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-dropdown full"><span class="option-name">' + opt + optSeparator +' <span class="option-value full">' + fullLabel + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                } else {
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-dropdown"><span class="option-name">' + opt + optSeparator +' <span class="option-value">' + option.values[0] + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                }
              } else {
                $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-dropdown"><span class="option-name">' + opt + '<div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
              }
            }
          } else if (optionStyle == 'mobile_dropdown'){
            if (showLabel){
              if (showFullSelection) {
                if (optValue.length >= optThreshold){
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-dropdown"><span class="option-name full">' + opt + optSeparator +' <span class="option-value full">' + fullLabel + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                } else if (optValue.length > 1 && optValue.length < optThreshold){
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-mobile-dropdown"><span class="option-name full">' + opt + optSeparator +' <span class="option-value full">' + fullLabel + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                } else {
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' solo-container full"><span class="option-name">' + opt + optSeparator +' <span class="option-value full">' + fullLabel + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                }
              } else {
                if (optValue.length >= optThreshold){
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-dropdown"><span class="option-name">' + opt + optSeparator +' <span class="option-value">' + option.values[0] + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                } else if (optValue.length > 1 && optValue.length < optThreshold){
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-mobile-dropdown"><span class="option-name">' + opt + optSeparator +' <span class="option-value">' + option.values[0] + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                } else {
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' solo-container"><span class="option-name">' + opt + optSeparator +' <span class="option-value">' + option.values[0] + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                }
              }
            } else {
              if (optValue.length >= optThreshold){
                $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-dropdown"><span class="option-name">' + opt + '<div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
              } else if (optValue.length > 1 && optValue.length < optThreshold){
                $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-mobile-dropdown"><span class="option-name">' + opt + optSeparator +' <span class="option-value">' + option.values[0] + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
              } else {
                $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' solo-container"><span class="option-name">' + opt + optSeparator +' <span class="option-value">' + option.values[0] + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
              }
            }
          /* If variant style is NOT set to dropdown except colors */
          } else {
            if (showLabel) {
              if (showFullSelection) {
                if (optValue.length >= optThreshold || optionStyle == 'dropdown' ){
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-dropdown full"><span class="option-name">' + opt + optSeparator +' <span class="option-value full">' + fullLabel + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                } else {
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container"><span class="option-name full">' + opt + optSeparator +' <span class="option-value full">' + fullLabel +'</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                }
              } else {
                if (optValue.length >= optThreshold || optionStyle == 'dropdown' ){
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-dropdown"><span class="option-name">' + opt + optSeparator +' <span class="option-value">' + option.values[0] + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                } else {
                  $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container"><span class="option-name">' + opt + optSeparator +' <span class="option-value">' + option.values[0] +'</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
                }
              }
            } else {
              if (optValue.length >= optThreshold || optionStyle == 'dropdown' ){
                $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container option-container-dropdown"><span class="option-name">' + opt + '<div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
              } else {
                $('.qv-product-options').append('<div class="option-selection-' + opt.toLowerCase() + ' option-container"><span class="option-name">' + opt + optSeparator +' <span class="option-value">' + option.values[0] + '</span><div class="arrow-down"></div></span><div class="option-' + i + ' option ' + opt.toLowerCase() + '"></div></div>');
              }
            }
          }
          
          $(option.values).each(function (i, value) {
            var swatchUrl = '//snowdam.s3.us-east-2.amazonaws.com/swatch/' +
              value.toLowerCase().replaceAll('/', '-').replaceAll(' ', '-') + '.png';
            var labelInner = isSwatch? '<img alt="' + value + '" src="' +
              swatchUrl +
              '" onerror="this.onerror=null;this.src=\'//snowdam.s3.us-east-2.amazonaws.com/swatch/broken-image.jpg\';">' : value;
            var labelClass = isSwatch? ' class="qv-swatch"' : '';
            let appendElement = `<input type="radio" id="${opt.toLowerCase()}-${value.toLowerCase().replaceAll('"', '&quot;')}" name="${opt}" value="${value.replaceAll('"', '&quot;')}" aria-label="${value.replaceAll('"', '&quot;')}"></input><label ${labelClass} for="${opt.toLowerCase()}-${value.toLowerCase().replaceAll('"', '&quot;')}">${labelInner}</label>`;
            if (optionStyle == 'dropdown') {
              if (isSwatch) {
                $(selectClass).append(
                  '<div class="selection-container"><input type="radio" id="' +
                  opt.toLowerCase() + '-' + value.toLowerCase() +
                  '" name="' + opt + '" value="' + value + '" aria-label=' + value + '"></input>' +
                  '<label' + labelClass + ' for="' + opt.toLowerCase() + '-' + value.toLowerCase() + '">' +
                   labelInner + '</label><span class="qv-swatch-label">' + opt.toLowerCase() + ' - ' + value.toLowerCase() + '</span></div>'
              );
              } else {
                $(selectClass).append(appendElement);
              }
            } else {
              $(selectClass).append(appendElement);
            }
          });
          $("input:radio[name='"+ opt + "']:first-of-type" ).prop('checked', true);
          $("input:radio[name='"+ opt + "']:first-of-type" ).attr('checked',true);
        });
        
        $(product.variants).each(function (i, v) {
          if (v.inventory_quantity == 0) {
            $('.qv-add-button').prop('disabled', true).val(window.variantStrings.soldOut);
            $('.qv-add-to-cart').hide();
            $('.qv-product-price').text('Sold Out').show();
            return true
          } else {
            price = parseFloat(v.price / 100).toFixed(2);
            original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            $('.qv-product-price').text('$' + price);
            if (original_price > 0) {
              $('.qv-product-original-price').text('$' + original_price).show();
              //Discount Percentage
              let discountPercentage = Math.round((1 - (price / original_price)) * 100);
              $('.qv-product-discount').text('Save ' + discountPercentage + '%');
            } else {
              $('.qv-product-discount').hide();
              $('.qv-product-original-price').hide();
            }
            $('select.option-0').val(v.option1);
            $('select.option-1').val(v.option2);
            $('select.option-2').val(v.option3);
            return false
          }
        });
      });
      $(document).on("change", "#quick-view input", function () {
        var selectedOptions = '';
        $('#quick-view input:radio:checked').each(function (i) {
          $(this).parent().prev().find('.option-name-selection').text($(this).val());
          $(this).parent().prev().find('.option-value').text($(this).val());
          $(this).closest(".option-container").find(".option-value").text($(this).val());
          let newLabelTransformed = $(this).val().replace(/^S$/g, "Small").replace(/^SM$/g, "Small").replace(/^M$/g, 'Medium').replace(/^XXXX/g, '4X-').replace(/^XXX/g, '3X-').replace(/^XX/g, '2X-').replace(/^X/g, 'X-').replace(/L$/g, 'Large');
          $(this).parent().prev().find('.option-name-selection.full').text(newLabelTransformed);
          $(this).parent().prev().find('.option-value.full').text(newLabelTransformed);
          $(this).closest(".option-container").find(".option-value.full").text(newLabelTransformed);
          $(this).attr("checked", "checked");
          $(this).siblings("input").each(function() {
            $(this).removeAttr("checked");
          })
          if (selectedOptions == '') {
            selectedOptions = $(this).val(); 
          } else {
            selectedOptions = selectedOptions + ' / ' + $(this).val();
          }
        });
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          $(product.variants).each(function (i, v) {
            if (v.title == selectedOptions) {
              var price = parseFloat(v.price / 100).toFixed(2);
              var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
              var v_qty = v.inventory_quantity;
              var v_inv = v.inventory_management;
              var v_sku = v.sku;
              window.postMessage({ type: 'variant_changed', variant: v, origin: "quick_view" }, '*')
              $('.qv-product-price').text('$' + price);
              if (original_price > 0) {
                $('.qv-product-original-price').text('$' + original_price);
                $('.qv-product-original-price').show();
                //Discount Percentage
              let discountPercentage = Math.round((1 - (price / original_price)) * 100);
              $('.qv-product-discount').text('Save ' + discountPercentage + '%');
              $('.qv-product-discount').show();
                } else {
                  $('.qv-product-original-price').hide();
                  $('.qv-product-discount').hide();
                }
              $('.qv-product-sku').text("ITEM NO. " + v_sku);
              var buttonLabel = show_preorder == true ? window.variantStrings.preOrder : window.variantStrings.addToCart;
              if (v_inv == null) {
                $('.qv-add-button').prop('disabled', false).val(buttonLabel);
              } else {
                if (v.available == false) {
                  $('.qv-add-button').prop('disabled', true).val(window.variantStrings.soldOut);
                } else {
                  $('.qv-add-button').prop('disabled', false).val(buttonLabel);
                }
              }
            }
          });
        });
      });
      $(document).on("change", "#quick-view select", function () {
        var selectedOptions = '';
        $('#quick-view select').each(function (i) {
          if (selectedOptions == '') {
            selectedOptions = $(this).val();
          } else {
            selectedOptions = selectedOptions + ' / ' + $(this).val();
          }
        });
        jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
          $(product.variants).each(function (i, v) {
            if (v.title == selectedOptions) {
              var price = parseFloat(v.price / 100).toFixed(2);
              var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
              window.postMessage({ type: 'variant_changed', variant: v }, '*')
              var v_qty = v.inventory_quantity;
              var v_inv = v.inventory_management;
              $('.qv-product-price').text('$' + price);
              if (original_price > 0) {
              $('.qv-product-original-price').text('$' + original_price);
              $('.qv-product-original-price').show();
              //Discount Percentage
              let discountPercentage = Math.round((1 - (price / original_price)) * 100);
              $('.qv-product-discount').text('Save ' + discountPercentage + '%');
              $('.qv-product-discount').show();
              } else {
                $('.qv-product-original-price').hide();
                $('.qv-product-discount').hide();
              }
              var buttonLabel = show_preorder == true ? window.variantStrings.preOrder : window.variantStrings.addToCart;
              if (v_inv == null) {
                $('.qv-add-button').prop('disabled', false).val(buttonLabel);
              } else {
                if (v.available == false) {
                  $('.qv-add-button').prop('disabled', true).val(window.variantStrings.soldOut);
                } else {
                  $('.qv-add-button').prop('disabled', false).val(buttonLabel);
                }
              }
            }
          });
        });
      });
      $.fancybox({
        href: '#quick-view',
        wrapCSS: 'fancy-quick-view',
        maxWidth: 1040,
        maxHeight: 600,
        fitToView: true,
        width: '80%',
        height: '70%',
        autoSize: false,
        closeClick: false,
        openEffect: 'none',
        closeEffect: 'none',
        live: false,
        'beforeLoad': function () {
          $('.fancybox-wrap').css('overflow', 'hidden !important');
        },
        'afterShow': function () {
          $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
            $('.qv-product-images, .qv-product-slider-nav').addClass('loaded');
          });
        },
        'afterClose': function () {
          $('#quick-view').removeClass().empty();
          window.postMessage({ type: 'quickview', action: "close" }, '*');
        }
      });
    });
   };
   
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });

 });
  
 jQuery(window).resize(function ($){
  if (jQuery('#quick-view').is(':visible')) {
    jQuery('.qv-product-images, .qv-product-slider-nav').slick('setPosition');
  }
 });